import { useBlockBrowserClose } from '@/hooks/useBlockBrowserClose';
import { GroupTranslation } from '@d-id/types';
import { FormProvider, useForm } from 'react-hook-form';
import { getTranslatedCaptions } from './api/captions';
import TranslationEditorPageHeader from './components/Header/TranslationEditorPageHeader';
import TranslationDraftEditor from './components/TranslationDraftEditor/TranslationDraftEditor';
import { TranslationGroupProofreadFormData } from './state/types';

interface IProps {
    translations?: GroupTranslation[];
}

async function fetchDefaultValues(translations?: GroupTranslation[]) {
    if (!translations) {
        return {};
    }
    const captions = await Promise.all(translations.map(translation => getTranslatedCaptions(translation)));

    const captionsByTranslationId = translations.reduce(
        (acc, translation, index) => ({
            ...acc,
            [translation.id]: captions[index],
        }),
        {}
    );

    return {
        captionsByTranslationId,
        selectedTranslationId: translations[0].id,
        selectedVoiceId: translations[0].custom_voice_id,
    };
}

function TranslationDraftEditorPage({ translations }: IProps) {
    const formMethods = useForm<TranslationGroupProofreadFormData>({
        defaultValues: async () => fetchDefaultValues(translations),
    });

    useBlockBrowserClose(() => formMethods.formState.isDirty);

    return (
        <FormProvider {...formMethods}>
            <TranslationEditorPageHeader />
            <TranslationDraftEditor />
        </FormProvider>
    );
}

export default TranslationDraftEditorPage;
